import { GridColDef } from '@mui/x-data-grid';
import CATEGORIES from 'constants/Categories';

export const getDataGridColumns = (): GridColDef[] => {
  return CATEGORIES.map(
    (_, index: number): GridColDef => ({
      field: `category${index + 1}`,
      headerName: `Cat ${index + 1}`,
      width: 90,
      editable: false,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
    }),
  );
};
